export class BimBuildingCamera {
    public alpha: number;
    public beta: number;
    public radius: number;
    public radiusLowerLimit: number;
    public radiusUpperLimit: number;
}
